import React, { Component } from 'react';
import Footer from '../ui/Footer';
import HomeImage from '../assets/homeimage/homeimage';
import './home.css';
import CategorieContainer from '../categoriecontainer/CategorieContainer';
import CourseContainer from '../coursecontainer/CourseContainer';
import Navbar from '../navbar/NavBar';


class Home extends Component {
  state = {categorie: "Development"}
    
  categorieSelectedtHandler = async ( type ) => {
      await this.setState({categorie: type});
  }


  render(){
    return(
    <div>
        <Navbar/>
        <div className="container">
        <div className="home-page">
          <div className="main-section">
            <HomeImage />
            <div className="home-desc">
              <h1>Learn on your own pace</h1>
              <p>Study Anytime, The Topic You Choose</p>
            </div>
          </div>
        </div>

        <div>
          <CategorieContainer courseCategorie={this.state.categorie}
                              categorieSelected={this.categorieSelectedtHandler} />
          <CourseContainer courseCategorie={this.state.categorie} />
          <Footer/>
        </div>
      </div>

      </div>
  )

  }
}

export default Home;


